<app-logo></app-logo>

<div class="h1 page-header mt-16">{{ 'IOFFER.RETURN.TITLE' | translate}}</div>

<ng-container *ngIf="status === statuses.PENDING">
    <div class="page-header-info">{{ 'IOFFER.RETURN.PENDING' | translate }}</div>
    <div class="mt-16">
        <mat-spinner style="margin:0 auto;" strokeWidth="3" diameter="30"></mat-spinner>
    </div>
</ng-container>

<div class="page-header-info" *ngIf="status === statuses.SUCCESS">{{ 'IOFFER.RETURN.PAID' | translate }}</div>

<div class="page-header-info" *ngIf="status === statuses.FAILURE">{{ 'IOFFER.RETURN.FAILURE' | translate }}</div>


